var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45842 10.5417H5.95841C5.80494 10.5417 5.67633 10.4901 5.57258 10.3871C5.46869 10.284 5.41675 10.1564 5.41675 10.0042C5.41675 9.8518 5.46869 9.72277 5.57258 9.61707C5.67633 9.51124 5.80494 9.45832 5.95841 9.45832H9.45842V5.95832C9.45842 5.80485 9.50994 5.67624 9.613 5.57249C9.71605 5.4686 9.84369 5.41666 9.99591 5.41666C10.1483 5.41666 10.2773 5.4686 10.383 5.57249C10.4888 5.67624 10.5417 5.80485 10.5417 5.95832V9.45832H14.0417C14.1952 9.45832 14.3238 9.50985 14.4276 9.61291C14.5315 9.71596 14.5834 9.8436 14.5834 9.99582C14.5834 10.1482 14.5315 10.2772 14.4276 10.3829C14.3238 10.4887 14.1952 10.5417 14.0417 10.5417H10.5417V14.0417C10.5417 14.1951 10.4902 14.3237 10.3872 14.4275C10.2841 14.5314 10.1565 14.5833 10.0042 14.5833C9.85189 14.5833 9.72286 14.5314 9.61716 14.4275C9.51133 14.3237 9.45842 14.1951 9.45842 14.0417V10.5417Z",
    fill: "#A7B0C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDisabled);
export default __webpack_public_path__ + "static/media/add_disabled.43946dff05eea25fa4e219f6eac846f6.svg";
export { ForwardRef as ReactComponent };